export default __webpack_public_path__ + "static/media/moot-court-10.7a2a5162.webp";